import './_header.scss';
import component from './header';

export default component;
